import "alpine-turbo-drive-adapter";
import Alpine from "alpinejs";

import { nestedForm, nestedFields } from "../alpine/nested_fields";
Alpine.data("nestedForm", nestedForm);
Alpine.data("nestedFields", nestedFields);

window.Alpine = Alpine;
window.Alpine.start();
